
define('ldsh!modules/estimate_contacts/create/template', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h1>EstimateContacts</h1>\n<div class="form form-horizontal" role="form">\n\n\n\n\n  \n\n  <div class="form-group">\n    <label for="estimate">estimate</label>\n    <select  class="form-control selectbox-estimate" id="estimate" name="estimate" ></select>\n  </div>\n\n\n\n\n\n\n\n\n  <button type="button" class="btn btn-default submitForm">Submit</button>\n</div>';

}
return __p
};});

